export type Manifest = {
  source: { fileName: string };
  settings: Record<string, unknown>;
  spriteer: { version: string };
};

export function buildManifest(input: {
  fileName: string;
  settings: Record<string, unknown>;
}): Manifest {
  return {
    source: { fileName: input.fileName },
    settings: input.settings,
    spriteer: { version: '0.2.0' },
  };
}
